var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 400,
        width: 1600,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { height: "50", width: "1520", y: "131.95001", x: "24.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "50", width: "723", y: "52.95001", x: "25" },
      }),
      _vm._v(" "),
      _c("rect", { attrs: { height: "50", width: "723", y: "53", x: "820" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "50", width: "723", y: "300.95001", x: "25" },
      }),
      _vm._v(" "),
      _c("rect", { attrs: { height: "50", width: "723", y: "300", x: "820" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "50", width: "723", y: "217.95001", x: "25" },
      }),
      _vm._v(" "),
      _c("rect", { attrs: { height: "50", width: "723", y: "218", x: "820" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }